'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isSelected", "multiselect", "selected", "allowClear", "onSelect"];
import { CommandItem } from "../_shadcn-native-components/command";
import { useDropdownContext } from "./context";
import { jsx as _jsx } from "react/jsx-runtime";
export var DropdownBaseItem = function DropdownBaseItem(_ref) {
  var isSelected = _ref.isSelected,
    multiselect = _ref.multiselect,
    selected = _ref.selected,
    allowClear = _ref.allowClear,
    onSelect = _ref.onSelect,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useDropdownContext = useDropdownContext(),
    items = _useDropdownContext.items,
    values = _useDropdownContext.values,
    selectedItems = _useDropdownContext.selectedItems,
    setValues = _useDropdownContext.setValues,
    setOpen = _useDropdownContext.setOpen;
  var handleItemSelected = function handleItemSelected(label) {
    var _items$find;
    var value = (_items$find = items.find(function (item) {
      return item.label.toLowerCase() === label;
    })) === null || _items$find === void 0 ? void 0 : _items$find.value;
    if (!value) return;
    if (multiselect) {
      var newValues = values.includes(value) ? values.filter(function (item) {
        return item !== value;
      }) : [].concat(_toConsumableArray(values), [value]);
      if (onSelect) onSelect(newValues);
      if (!selected) setValues(newValues);
    } else {
      var isValueSelected = !!selectedItems.find(function (selected) {
        return selected.value === value;
      });
      var valueToPropagate = isValueSelected && allowClear ? null : value;
      if (onSelect && allowClear) onSelect(valueToPropagate);
      if (onSelect && !allowClear) onSelect(value);
      if (!selected) setValues(valueToPropagate ? [valueToPropagate] : []);
      setOpen(false);
    }
  };
  return /*#__PURE__*/_jsx(CommandItem, _objectSpread({
    onSelect: handleItemSelected,
    selected: isSelected
  }, props));
};